import { render, staticRenderFns } from "./listCopy.vue?vue&type=template&id=700c93b9&scoped=true"
import script from "./listCopy.vue?vue&type=script&lang=js"
export * from "./listCopy.vue?vue&type=script&lang=js"
import style0 from "./listCopy.vue?vue&type=style&index=0&id=700c93b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c93b9",
  null
  
)

export default component.exports